import React, { useState } from 'react';
import { Box, Typography, Divider, Button, IconButton, Stack, ListItemIcon } from '@mui/material';
import { useOutletContext } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { esignIcons } from './icons';
import AddSigners from './addSigners';
import Security from './security';
import Email from './email'
import { useLogger } from '../../hooks/useLogger';

export default function PdfMiniSidenav({ containerRef, pdfPagesRef, pdfPages }) {
  const { open, setOpenSideBar, openSideBar } = useOutletContext();
  const logEvent = useLogger();
  const [activeTab, setActiveTab] = useState("Signers");
  console.log(openSideBar)
  const sidebarItems = [
    { label: "Signers", icon: activeTab === 'Signers' ? esignIcons.GroupsIconActive : esignIcons.GroupsIcon, key: "Signers", clickable: true },
    { label: "Security", icon: activeTab=="Security" ? esignIcons.SecurityIconActive : esignIcons.SecurityIcon, key: "Security", clickable: false },
    { label: "Email", icon: activeTab=="Email" ? esignIcons.EmailIconActive : esignIcons.EmailIcon, key: "Email", clickable: false },
  ];

  return (
    <Box mt={10} style={{ display:"flex", borderRadius: '12px 0 0 12px', textAlign: 'center', background: '#fff', width: openSideBar ? '35%' : '6%', height: "calc(100% - 77px)", marginLeft: open ? "" : "1em", }} >
        {activeTab=="Signers" && (
            <AddSigners containerRef={containerRef} pdfPagesRef={pdfPagesRef} pdfPages={pdfPages} />
        )}
        {activeTab=="Security" && (
            <Security containerRef={containerRef} pdfPagesRef={pdfPagesRef} pdfPages={pdfPages} />
        )}
        {activeTab=="Email" && (
            <Email containerRef={containerRef} pdfPagesRef={pdfPagesRef} pdfPages={pdfPages} />
        )}
        <Divider orientation="vertical" flexItem sx={{ borderWidth: openSideBar ? "0 0 0 thin !important" : "0px", margin: 0 }} />
        
        <Stack sx={{ height: '100%', width: openSideBar ? '20%' : '100%' }}>
            <Box sx={{ width: '100%', height: "100%", position: "relative", pt: 2 }}>
            {sidebarItems.map(({ label, icon, key, clickable }) => (
                <Box
                    key={key}
                    sx={{
                    width: "100%",
                    padding: "12px",
                    cursor: clickable ? "pointer" : "default",
                    transition: "background 0.3s ease",
                    color: activeTab === key ? "#185CB7" : "#666",
                    }}
                    onClick={() => {                        
                        logEvent('Click', `Clicked on ${key}`, `new-esign/${key}`);
                        if (clickable) {
                            if (activeTab === key) {
                            setOpenSideBar(true);
                            } else {
                            setActiveTab(key);
                            setOpenSideBar(true);
                            }
                        }
                    }}
                >
                    <Box sx={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <ListItemIcon
                            sx={{
                            display: "flex",
                            background: activeTab === key ? "#E6F1FF" : "#0000000F",
                            width: "60px",
                            height: "60px",
                            borderRadius: "100%",
                            border: activeTab === key ? "1px solid #CCE2FE" : "none",
                            alignItems: "center",
                            justifyContent: "center",
                            }}
                        >
                            {icon}
                        </ListItemIcon>

                        {(label === "Email" || label === "Security") && (
                            <Box
                            component="img"
                            src={`${process.env.PUBLIC_URL}/images/diamond.png`}
                            alt="Credit"
                            sx={{
                                width: 20,
                                height: 20,
                                background: "#ffffff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "45px", // Slightly overlapping bottom of the circle
                            }}
                            />
                        )}

                        <Typography sx={{ fontSize: "14px", mt: 1 }}>{label}</Typography>
                    </Box>
                </Box>
                ))}


                {/* <IconButton
                    onClick={() => setOpenSideBar(!openSideBar)}
                    sx={{
                        position: "absolute",
                        bottom: 16,
                        background: "#F0F6FF",
                        boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
                        width: "45px",
                        height: "45px",
                        left: '50%',
                        transform: "translateX(-50%)",
                    }}
                    >
                    {openSideBar ? <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.06779 14.983L8.55085 8.5L2.06779 2.01695" stroke="#185CB7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg> : <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.55084 14.983L2.06779 8.49998L8.55084 2.01693" stroke="#185CB7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>}
                </IconButton> */}
            </Box>
        </Stack>
        
    </Box>
  );
}
